import Tag from '../Tag'
import {
  Icon,
  Icons,
  SelectList, TypographyElement
} from 'UI'
import Text from './text.json'
import { useEffect, useState } from 'react'
import { ProfileTypes, allCoursesId } from 'constants/'
import { freeCoursesTag } from '../store'
import { createUseStyles, useTheme } from 'react-jss'
import style from './style'

const useStyle = createUseStyles(style)

const skeletonTagsLength = 8

export default ({ tags = [], selectedTag, handleTagClick, selectList, selectedCategory, loading, profileType }) => {
  const theme = useTheme()
  const [showMore, setShowMore] = useState(false)
  useEffect(() => { setShowMore(false) }, [selectedCategory])
  const isSubscribed = profileType === ProfileTypes.BasicSubscriber || profileType === ProfileTypes.PremiumSubscriber
  const filteredTags = !isSubscribed ? tags : tags.filter(tag => tag.Name !== freeCoursesTag.Name)
  const tagsToShow = loading ? [...Array(skeletonTagsLength).fill(true)] : filteredTags

  const { showMoreStyle, tagsRow } = useStyle()

  if (selectedCategory.Id === allCoursesId) return null
  return selectList
    ? (
      <SelectList
        idField='Id'
        valueField='Name'
        items={tags}
        onSelectedItem={(tag) => handleTagClick(tag)}
        selectedItem={selectedTag.Id ? selectedTag.Name : Text.subCategories}
        selectedLabel={selectedTag.Id ? `${selectedTag.Name} (${selectedTag.NumberOfCourses})` : Text.subCategories}
        gutterBottom={24}
      />
      )
    : (
      <>
        <div className={tagsRow}>
          {
            (showMore ? tagsToShow : tagsToShow.slice(0, 10)).map((tag, key) =>
              <Tag
                loading={loading}
                key={tag.Id || key} {...tag}
                active={selectedTag.Id === tag.Id}
                handleTagClick={handleTagClick}
              />
            )
          }
        </div>
        {
          tagsToShow.length > 10
            ? (
              <TypographyElement
                handleClick={() => setShowMore(!showMore)}
                variant='button'
                color={theme.primary[0]}
                cursor='pointer'
                display='flex'
                className={showMoreStyle}
                spacing='16px 0 0 0'
              >
                {showMore ? Text.showLess : Text.showMore}
                <Icon iconName={showMore ? Icons.roundedUp : Icons.roundedDown} />
              </TypographyElement>
              )
            : null
        }
      </>
      )
}
